import { Injectable, signal } from '@angular/core';

export interface MenuItem {
  id: string;
  title: string;
  icon: string;
  route: string ;
  badge?: number;
  children?: MenuItem[];
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  isMobileOrTablet = signal<boolean>(false);

  isMobile = signal<boolean>(false);
  
  isTablet = signal<boolean>(false);

  isDesktop = signal<boolean>(false);

  sidebarCollapsed = signal(false);
  
  activeRoute = signal('dashboard');
  
  title = signal('');
  
  menuItems = signal<MenuItem[]>([]);

  isChromiumBased = signal<boolean>(false);
  
}